import $ from 'jquery';
import Swiper from 'swiper';

new Swiper('.players-block-slider', {
    slidesPerView: 'auto',
    spaceBetween: 30,
});

$('.feed-player-title').each(function () {
    const $this = $(this);
    $this.html($this.html().replace(/(\S+)\s*$/, '<span>$1</span>'));
});
